import { createSelector } from 'reselect'
import * as constants from './constants'

export const root = (state) => state.get('campaigns')

export const campaign = (id) => createSelector(
  root,
  (root) => root.getIn(['byId', id])
)

export const fetchStatus = (id) => createSelector(
  root,
  (root) => root.getIn(['statusById', id])
)

export const isCampaignUpdating = (id) => createSelector(
  fetchStatus(id),
  (fetchStatus) => fetchStatus === constants.UPDATE_CAMPAIGN ||
                 fetchStatus === constants.UPDATE_CAMPAIGN_PENDING
)

export const isCampaignLoading = (id) => createSelector(
  fetchStatus(id),
  (fetchStatus) => fetchStatus === constants.FETCH_CAMPAIGN ||
                 fetchStatus === constants.FETCH_CAMPAIGN_PENDING
)

export const isCampaignFetched = (id) => createSelector(
  root,
  (root) => root.hasIn(['byId', id])
)

export const searchResults = createSelector(
  root,
  (root) => root.getIn(['searchResults', 'data'])
)

export const searchStatus = createSelector(
  searchResults,
  (searchResults) => searchResults.get('status')
)

export const isLoadingSearchResults = createSelector(
  searchStatus,
  (searchStatus) => searchStatus === constants.SEARCH_CAMPAIGNS ||
                  searchStatus === constants.SEARCH_CAMPAIGNS_PENDING
)

export const isLoadingMore = createSelector(
  searchStatus,
  (searchStatus) => searchStatus === constants.LOAD_MORE_CAMPAIGNS ||
                  searchStatus === constants.LOAD_MORE_CAMPAIGNS_PENDING
)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/campaigns/selectors.js